import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';

import { CoreRoutingModule } from './core-routing.module';
import { Components } from './components';
import { Pages } from './pages';

// NOTE: the data/3D services (ArticleService, ProjectService, BomService, …) are
// now `providedIn: 'root'` and intentionally NOT listed here. CoreModule is eager
// (imported by AppModule), so providing the three.js-coupled services here forced
// three's geometry core into the initial bundle that the public site loads. Root
// provision keeps the same singleton behaviour while letting the bundler push
// them into the lazy configurator/preview chunks that actually use them.
@NgModule({
	declarations: [Components, Pages],
	imports: [
		CommonModule,
		SharedModule,
		CoreRoutingModule,
		ReactiveFormsModule,
	],
	exports: [Components],
})
export class CoreModule {}
